import { useGetCurrentUser } from '@entities/user';
import { BaseGrid } from '@evrone-erp/uikit';
import { Box, Typography } from '@mui/material';
import { ROUTES } from '@shared';
import { BaseContainer } from '@shared/ui/base-container/BaseContainer';
import { ReadOnlyCredentialsPlate } from '@widgets/credentials/readonly-credentials-plate';
import { General } from '@widgets/general/ui/General';
import { Photo } from '@widgets/photo/ui/Photo';
import { TotpPlate } from '@widgets/totp/ui/TotpPlate';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
export const AccountPage = () => {
  const {
    t
  } = useTranslation('account');
  const {
    data: user,
    isLoading
  } = useGetCurrentUser();
  const {
    email: login = '',
    avatar,
    name,
    surname,
    otpEnabled
  } = user || {};
  const {
    push
  } = useRouter();
  const handleRedirectToCredentialsPage = () => {
    push(ROUTES.credentials);
  };
  const handleRedirectToPhotoPage = useCallback(() => {
    push(ROUTES.photo);
  }, [push]);
  const handleChangeTotpPage = useCallback(() => {
    if (otpEnabled) {
      push(ROUTES.totpReset);
      return;
    }
    push(ROUTES.totp);
  }, [push, otpEnabled]);
  const editGeneral = useCallback(() => push(ROUTES.generalEdit, undefined), [push]);
  return <BaseContainer contentPosition="bottom">
      <Box>
        <Typography marginBottom="14px" component="h1" variant="title">
          {t('account')}
        </Typography>
        <BaseGrid container>
          <BaseGrid item mob={12} tab={6} lap={4} desk={4}>
            <ReadOnlyCredentialsPlate login={login} onClick={handleRedirectToCredentialsPage} />
          </BaseGrid>
          <BaseGrid item mob={12} tab={6} lap={4} desk={4}>
            <General name={name} surname={surname} onClick={editGeneral} isLoading={isLoading} />
          </BaseGrid>
          <BaseGrid item mob={12} tab={6} lap={4} desk={4}>
            <Photo title={t('photo')} avatar={avatar} onClick={handleRedirectToPhotoPage} isLoading={isLoading} />
          </BaseGrid>
          <BaseGrid item mob={12} tab={6} lap={4} desk={4}>
            <TotpPlate otpEnabled={otpEnabled} onChangeOtp={handleChangeTotpPage} isLoading={isLoading} />
          </BaseGrid>
        </BaseGrid>
      </Box>
    </BaseContainer>;
};